import { FETCH_USER_GENERAL_INFO, LOGOUT } from '../constants/ActionTypes';
import {
  _PENDING,
  _REJECTED,
  _FULFILLED
} from '../constants/PromiseMiddleware';

const defaultStore = {
  name: null,
  lastname: null,
  email: null,
  type: null,
  permits: { dataSource: [] },
  isFetching: false,
  isAdmin: false,
  id: null
};

const userProfile = (state = defaultStore, action) => {
  switch (action.type) {
    case LOGOUT:
      return defaultStore;

    case FETCH_USER_GENERAL_INFO:
      return { ...state };

    case FETCH_USER_GENERAL_INFO + _PENDING:
      return { ...state, isFetching: true };

    case FETCH_USER_GENERAL_INFO + _REJECTED:
      return { ...state, isFetching: false };

    // TODO: Take down the permits, for testing.
    case FETCH_USER_GENERAL_INFO + _FULFILLED:
      const user = action.payload.data.result.user;

      return {
        ...state,
        name: user.name,
        lastname: user.lastName,
        email: user.mail,
        type: user.type,
        isFetching: false,
        isAdmin: user.isAdmin,
        id: user.id
      };
    default:
      return state;
  }
};

module.exports = userProfile;



// WEBPACK FOOTER //
// ./reducers/userProfileReducer.js